import { fmtUsd, fmtPrice, short } from "../../lib/format";

const Row = ({ label, value, sub, tone = "text-slate-100", testId }) => (
  <div className="flex items-start justify-between py-2 border-b border-line/60 last:border-0">
    <span className="text-xs text-slate-400">{label}</span>
    <div className="text-right"><div className={`mono text-sm ${tone}`} data-testid={testId}>{value}</div>{sub && <div className="mono text-[10px] text-fog">{sub}</div>}</div>
  </div>
);

const Meter = ({ pct, tone }) => (
  <div className="h-1 bg-ink rounded-sm mt-1 overflow-hidden"><div className="h-full" style={{ width: `${Math.min(100, pct)}%`, background: tone }} /></div>
);

export const TrustPanel = ({ token }) => {
  if (!token) return null;
  const ageH = token.age_hours;
  const age = ageH < 48 ? `${ageH.toFixed(0)}h` : `${(ageH / 24).toFixed(1)}d`;
  const riskTone = token.risk_score < 25 ? "#10B981" : token.risk_score < 50 ? "#F59E0B" : "#F43F5E";
  const riskText = token.risk_score < 25 ? "text-pos" : token.risk_score < 50 ? "text-warn" : "text-neg";
  return (
    <div className="px-4 py-3" data-testid="token-trust-panel-container">
      <div className="flex items-start justify-between mb-2">
        <div>
          <div className="font-heading font-semibold text-white flex items-center gap-1.5">{token.symbol}<span className="tag border-violet/40 text-violet-300 h-4">/{token.stock}</span> <span className="text-fog font-normal text-sm">{token.name}</span></div>
          <div className="mono text-[11px] text-fog">{short(token.address)} · deployer {short(token.deployer_address)}</div>
        </div>
        <div className="text-right">
          <div className="eyebrow">Risk</div>
          <div className={`mono text-lg font-semibold ${riskText}`} data-testid="trust-risk-label">{token.risk_label} <span className="text-xs text-fog">{token.risk_score}/100</span></div>
        </div>
      </div>
      <Meter pct={token.risk_score} tone={riskTone} />
      <div className="mt-2">
        <Row label="Paired against" value={`${token.stock} · ${token.stock_name}`} sub={`ref price ${fmtUsd(token.stock_price_usd, 2)} · own Uniswap v4 pool`} testId="trust-pair" />
        <Row label="Pool depth" value={fmtUsd(token.pool_depth_usd)} sub={`price ${fmtPrice(token.pool_price_usd)}/M`} testId="trust-pool-depth" />
        <Row label="Top 10 holders" value={`${token.top10_pct.toFixed(1)}%`} tone={token.top10_pct > 45 ? "text-neg" : token.top10_pct > 30 ? "text-warn" : "text-pos"} sub={`${token.holder_count.toLocaleString()} holders`} testId="trust-top-holders" />
        <Row label="Deployer holds" value={`${token.deployer_pct.toFixed(1)}%`} tone={token.deployer_pct > 8 ? "text-neg" : token.deployer_pct > 3 ? "text-warn" : "text-pos"} testId="trust-deployer-pct" />
        <Row label="Time since launch" value={age} tone={ageH < 24 ? "text-warn" : "text-slate-100"} sub={new Date(token.launched_at).toUTCString().slice(5, 22)} testId="trust-age" />
        <Row label="LP status" value={token.lp_locked ? "LOCKED · PERMANENT" : "UNLOCKED"} tone={token.lp_locked ? "text-pos" : "text-neg"} sub="Uniswap v4 LP locked at launch" testId="trust-lp-status" />
      </div>
      <p className="text-[11px] text-fog mt-2">Signals are read from chain state and are informational. They do not affect escrow logic.</p>
    </div>
  );
};
